import angular from 'angular'

angular.module('nominas.empresasconceptos')
  .service('NominasEmpresasconceptos', NominasEmpresasconceptos);

function NominasEmpresasconceptos($http) {
  this.get = function (idProyecto) {
    return $http.get('/api/proyectos/proyecto/configuracion/servicios', {
      params: {id_proyecto: idProyecto},
      schema: this.schema,
    });
  }.bind(this);

  this.put = function (idProyecto, data) {
    return $http.put('/api/proyectos/proyecto/configuracion/servicios', data, {
      params: {id_proyecto: idProyecto},
      schema: this.schema,
    });
  }.bind(this);

  this.schema = {
    activo: 'boolean',
    editable: 'boolean',
  };
}



// WEBPACK FOOTER //
// ./src/nominas/empresasconceptos/services/NominasEmpresasconceptos.js